/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { WeatherStationDataStat } from '../../models/weather-station-data-stat';

export interface GetStats$Params {
   /**
    * Start date in format YYYY-MM-DD (inclusive).
    */
   startDate?: string;

   /**
    * End date in format YYYY-MM-DD (exclusive).
    */
   endDate?: string;

   /**
    * Provider id (IBM,EPA5,etc)
    */
   providerId?: string;

   /**
    * Latitude
    */
   lat: number;

   /**
    * Longitude
    */
   lon: number;

   /**
    * Weather calculation mode (avg, near)
    */
   mode?: string;
}

export function getStats(
   http: HttpClient,
   rootUrl: string,
   params: GetStats$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Array<WeatherStationDataStat>>> {
   const rb = new RequestBuilder(rootUrl, getStats.PATH, 'get');
   if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('endDate', params.endDate, {});
      rb.query('providerId', params.providerId, {});
      rb.query('lat', params.lat, {});
      rb.query('lon', params.lon, {});
      rb.query('mode', params.mode, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Array<WeatherStationDataStat>>;
      })
   );
}

getStats.PATH = '/api/weather/weather/stats';
